import React from 'react'
import numeral from 'numeral'
import { pick } from 'lodash'
import { createSelector } from 'reselect'
import { FormattedMessage } from 'react-intl'

export const getLotInfo = ({ lots }) => lots.single.data
export const getSimilarLots = ({ lots }) => lots.single.similar
export const getLotsList = ({ lots }) => lots.list.items
export const getLotsKeys = ({ lots }, { type }) => lots.list.keys[type] || []
export const getCountIndex = ({ lots }, { type }) => lots.list.count[type] || 0

//
export const getComposedName = (persons = []) => {
  const length = persons.length - 1
  return persons.reduce((result, item, i) => {
    result += item.name + (
      (i !== length) ? ((i < length - 1) ? ', ' : ' ' + (<FormattedMessage id='common.and' />) + ' ') : ''
    )
    return result
  }, '')
}

export const reformatLot = item => {
  let stats = item.bidsStats || {}
  return ({
    ...item,
    title: getComposedName(item.persons),
    sum: stats.lastBid ? (numeral(stats.lastBid).format('0,0') + ' ' + stats.currencySymbol) : null
  })
}
//

export const getCountForIndex = () => createSelector(
  [ getCountIndex ],
  count => count
)

export const getLotsForIndex = () => createSelector(
  [ getLotsList, getLotsKeys ],
  (items = {}, keys = []) => ({ items: pick(items, keys), keys })
)

export const getLotName = createSelector(
  [ getLotInfo ],
  (data = {}) => {
    if (!data.persons || !data.persons.length) return null
    return getComposedName(data.persons)
  }
)

export const getLastBidValue = createSelector(
  [ getLotInfo ],
  (data = {}) => {
    if (!data.bidsStats) return null
    return (data.bidsStats.lastBid ? numeral(data.bidsStats.lastBid).format('0,0') : 0) + ' ' + data.bidsStats.currencySymbol
  }
)



// WEBPACK FOOTER //
// ./src/selectors/lots.js